import React, { useRef } from "react";
import AsyncSelect from "react-select/async";
import Select, { components } from "react-select";
import "../styles/MultiSelectFilter.css"

const CustomValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue } = props;
  const values = getValue();

  // const childArray = React.Children.toArray(children);

  // const input = childArray.find(
  //   child => child && child.type && child.type.name === "Input"
  // );

  // const placeholder = childArray.find(
  //   child => child && child.type && child.type.name === "Placeholder"
  // );

  const childArray = React.Children.toArray(children);

  const input = childArray.find(
    child => child && child.type === components.Input
  );

  const placeholder = childArray.find(
    child => child && child.type === components.Placeholder
  );


  let displayLabel = "";
  let extraCount = 0;

  if (values.length === 1) {
    displayLabel = values[0].label;
  } else if (values.length > 1) {
    displayLabel = values[0].label;
    extraCount = values.length - 1;
  }

  return (
    <components.ValueContainer {...props}>
      {!hasValue && placeholder}

      {hasValue && (
        <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
          <div
            style={{
              background: "#F0F4F8",
              color: "#19324C",
              fontSize: "12px",
              padding: "2px 8px",
              borderRadius: "6px",
              maxWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {displayLabel}
          </div>

          {extraCount > 0 && (
            <div
              style={{
                background: "#E4E7EC",
                fontSize: "11px",
                padding: "2px 6px",
                borderRadius: "6px"
              }}
            >
              +{extraCount}
            </div>
          )}
        </div>
      )}

      {input}
    </components.ValueContainer>
  );
};

const CustomMenuList = (props) => {
  const { options, selectProps } = props;
  const { onChange } = selectProps;

  return (
    <components.MenuList {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "8px",
          borderBottom: "1px solid #eee",
          fontSize: "12px"
        }}
      >
        <span style={{ cursor: "pointer", color: "#454CF2" }} onClick={() => onChange(options)}>
          Select All
        </span>

        <span style={{ cursor: "pointer", color: "#454CF2" }} onClick={() => onChange([])}>
          Deselect All
        </span>
      </div>

      {props.children}
    </components.MenuList>
  );
};

const customMultiSelect = {
  isMulti: true,
  closeMenuOnSelect: false,
  hideSelectedOptions: false,
  components: {
    DropdownIndicator: null,
    IndicatorSeparator: null,
    ValueContainer: CustomValueContainer,
    MenuList: CustomMenuList,
    Option: ({ children, ...props }) => (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{ marginRight: "8px" }}
          />
          {children}
        </div>
      </components.Option>
    )
  }
};

const MultiSelectFilter = ({
  label,
  value,
  onChange,
  loadOptions,
  options,
  isAsync = true,
  placeholder,
  styles
}) => {
  const selectRef = useRef(null);

  const focusSelect = () => {
    setTimeout(() => {
      selectRef.current?.focus();
    }, 0);
  };

  return (
    <div className="filter-field multiselect-filter-hover-parent">

      <p className="filter-text multiselect-filter-hover-trigger">
        {label}

        {value.length > 0 && (
          <>
            {" "}
            <span className="multiselect-filter-count-badge">
              {value.length}
            </span>
          </>
        )}

        {value.length > 0 && (
          <div className="multiselect-filter-hover-drawer">
            <strong>Selected {label} ({value.length})</strong>

            <div className="multiselect-filter-hover-items">
              {value.map((item, index) => (
                <span key={index} className="multiselect-filter-hover-item">
                  {item.label}
                </span>
              ))}
            </div>
          </div>
        )}
      </p>

      {isAsync ? (
        <AsyncSelect
          ref={selectRef}
          {...customMultiSelect}
          value={value}
          onChange={(selected) => {
            onChange(selected || []);
            focusSelect();
          }}
          loadOptions={loadOptions}
          defaultOptions
          isClearable
          placeholder={placeholder}
          styles={styles}
          menuPortalTarget={document.body}
        />
      ) : (
        <Select
          ref={selectRef}
          {...customMultiSelect}
          value={value}
          onChange={(selected) => {
            onChange(selected || []);
            focusSelect();
          }}
          options={options}
          isClearable
          placeholder={placeholder}
          styles={styles}
          menuPortalTarget={document.body}
        />
      )}
    </div>
  );
};

export default MultiSelectFilter;